
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import moment from 'moment';

let infos: any = [];
let answer = '';  // 回答内容
let msgTimer;
@Options({
  data() {
    return {
      wait: false,
      list: [],
      message: [],
      isChat: false,
      isLoad: true,
      isWait: false,
    }
  },
  computed: {
    ...mapState(['aid', 'userInfo', 'shareData', 'activityData'])
  },
  mounted () {
    this.$common.pageLoaded()
    this.$common.track('load', '进入两会100问')
    const shareData = JSON.parse(JSON.stringify(this.shareData))
    this.$common.onshare(shareData)
    this.getList();
    this.waitText();
  },
  methods: {
    toBottom() {
      this.$refs.content.scrollTo({
        top: this.$refs.content.scrollHeight,
        behavior: 'smooth'
      });
    },
    waitText() {
      setInterval(() => {
        this.wait = !this.wait;
      }, 1000);
    },
    async getList() {
      const res = await this.$request('/vote', {
        aid: this.aid,
        rows: 1000,
        field: 'type',
        keyword: 'qa'
      });

      const list = res.list;
      infos = [];

      list.forEach(item => {
        infos.push({
          q: item.info.title,
          a: item.info.intro,
        });
      });
      
      this.rdmList();
    },
    // 随机问题
    rdmList() {
      infos.sort((a, b) => {
        return Math.random() - 0.5;
      });

      this.list = infos.slice(0, 3).sort((a, b) => {
        return a.q.length - b.q.length;
      });

      this.$nextTick(() => {
        this.isLoad = true;
        this.isWait = true;
        const timer = setTimeout(() => {
          clearTimeout(timer);
          this.isWait = false;
        }, 2000);
      });
    },
    handleReload() {
      this.$common.track('click', '点击换一换');
      this.isLoad = false;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        this.rdmList();
      }, 100);
    },
    handleQa(info) {
      this.message.push({
        role: 'user',
        content: info.q,
        time: moment().format('MM-DD HH:mm'),
      });
      this.message.push({
        role: 'xf',
        content: '',
      });

      answer = info.a;
      this.$common.track('click', '选择问题：' + info.a);
      this.showMsg();
      this.$nextTick(() => {
        this.toBottom();  // 滑动到底部
      });
    },
    showMsg() {
      const message = this.message;
      let index = 1;
      this.isChat = true;
      clearInterval(msgTimer);
      msgTimer = setInterval(() => {
        message[message.length - 1].content = answer.slice(0, index);
        if (index % 40 === 0) {
          this.toBottom();
        }
        index++;
        if (index > answer.length) {
          clearInterval(msgTimer);
          this.isChat = false;
          setTimeout(() => {
            infos.sort((a, b) => {
              return Math.random() - 0.5;
            });

            this.message.push({
              role: 'question',
              list: infos.slice(0, 3).sort((a, b) => {
                return a.q.length - b.q.length;
              })
            });

            this.$nextTick(() => {
              this.toBottom();  // 滑动到底部
            });
          }, 3000);
        }
      }, 100);
    },
    handleReloadMesage(index) {
      this.message[index].list = [];
      setTimeout(() => {
        infos.sort((a, b) => {
          return Math.random() - 0.5;
        });

        this.message[index].list = infos.slice(0, 3).sort((a, b) => {
          return a.q.length - b.q.length;
        })

        // 如果点击最后一个换一换
        if (index === this.message.length - 1) {
          this.$nextTick(() => {
            this.toBottom();  // 滑动到底部
          });
        }
      }, 100);
    },
  },
})
export default class Home extends Vue {}
